import type { UIDocumentStep } from './types'

export function getDocumentStepUrl(
  documentKey: string,
  step: UIDocumentStep,
  options: { queryParamsToOmit?: string[]; queryParams?: Record<string, string> } = {},
) {
  // Preserve current URL search params to maintain filters when navigating
  const currentSearchParams = new URLSearchParams(window.location.search)
  if (options.queryParamsToOmit) {
    options.queryParamsToOmit.forEach((param) => {
      currentSearchParams.delete(param)
    })
  }
  if (options.queryParams) {
    Object.entries(options.queryParams).forEach(([key, value]) => {
      currentSearchParams.set(key, value)
    })
  }
  const searchParamsString = currentSearchParams.toString()
  const queryString = searchParamsString ? `?${searchParamsString}` : ''

  switch (step) {
    case 'classification':
      return `/documents/${documentKey}/classification${queryString}`
    case 'data':
      return `/documents/${documentKey}/data-extraction${queryString}`
    case 'carc_rarc':
      return `/documents/${documentKey}/tagging${queryString}`
    case 'patient':
      return `/documents/${documentKey}/matching${queryString}`
    case 'eob_payment_deposit':
      return `/documents/${documentKey}/payment-deposit${queryString}`
    case 'eob_duplication':
      return `/documents/${documentKey}/duplication${queryString}`
    case 'eob_processing':
      return `/documents/${documentKey}/eob-processing${queryString}`
    default:
      return `/documents/${documentKey}/classification${queryString}`
  }
}
